import React from 'react';
import ReactDOM from 'react-dom';
import './resume.css';
import Resume from './Resume.js';

let useResume = 'resumeData-Nigel.json'; //could be from GET or POST

let xhttp = new XMLHttpRequest();
xhttp.onreadystatechange = function() {
    if (this.readyState === 4 && this.status === 200) {
        let data = {};
        try{
            data = JSON.parse(xhttp.responseText);
        }
        catch(ex){
            data = {};
        }
        ReactDOM.render(<Resume data={data}/>, document.getElementById('root'));
    }
};

xhttp.open("GET", `${process.env.PUBLIC_URL}/json/${useResume}`, true);
xhttp.send();


// WEBPACK FOOTER //
// ./src/index.js